import React, { useEffect } from "react";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TEXT } from "../../dark-theme/palette";
import UserLayout from "../route/UserLayout";
import UserCustomButton from "../components/UserCustomButton";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        trackEvent("entered", { name: "NotFound" });
    }, []);

    const handleGoHome = () => {
        navigate("/");
    };

    const handleGoLibrary = () => {
        navigate("/account/library");
    };

    return (
        <UserLayout>
            <Box sx={{ flexGrow: 1 }}>
                <Box
                    sx={{
                        padding: "160px",
                        color: TEXT.primary,
                        display: "flex",
                        justifyContent: "flex-start",
                        textAlign: "left",
                        minHeight: "100vh",
                    }}
                >
                    <Box sx={{ width: "100%" }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                            <ErrorOutlineIcon sx={{ fontSize: 64, color: "#ff9800", mr: 2 }} />
                            <Typography variant="h3" sx={{ color: TEXT.primary, fontWeight: 600 }}>
                                Puzzle Not Found
                            </Typography>
                        </Box>
                        <Typography variant="h6" sx={{ color: TEXT.primary, mb: 2 }}>
                            We couldn't find the puzzle you're looking for.
                        </Typography>
                        <Typography variant="body1" sx={{ color: TEXT.secondary, mb: 4 }}>
                            The puzzle may have been removed, the link may be incorrect, or you may not have permission to access it.
                            Please check the link or try browsing our puzzle library.
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                            <UserCustomButton onClick={handleGoHome}>
                                Go to Home
                            </UserCustomButton>
                            <Button
                                variant="outlined"
                                onClick={handleGoLibrary}
                                sx={{
                                    color: "#3BA666",
                                    borderColor: "#3BA666",
                                    "&:hover": {
                                        borderColor: "#3BA666",
                                        backgroundColor: "rgba(59, 166, 102, 0.04)",
                                    },
                                }}
                            >
                                Browse Library
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </UserLayout>
    );
}
